<div class="title">
  {{ title }}
</div>
<ul class="items">
  <li *ngFor="let option of model">
    <label
      ><input type="checkbox" [checked]="option.checked" (change)="toggleOption(option)" /><span>
        {{ option.name }}
      </span></label
    >
  </li>
</ul>
